__turbopack_context__.v({
  "portalElement": "Portal-module-scss-module__BgJEla__portalElement",
});
